// components/ui/iconButtonClass.ts
// Icon buttons on flat panels: a square with padding, no outline and no fill at rest; only hover
// paints. A button sitting on top of media keeps its own fill for legibility.
export const ICON_BUTTON_CLASS =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-white/70 transition-colors hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-35';
